
function About() {

  	return (
		<div id="about">
            <div className="head">
                <h1>About</h1>
            </div>
            <div className="body">
                <p>DotAI is a side project I made to simplify hero selection during crucial drafting phases. The built-in Dota 2 hero categorization often doesn't do the job effectively. DotAI acts as a tool for sorting heroes based on what's good for your team, and what's bad for the enemy, making hero selection smarter , faster and easier.
                    <br/>
                    <br/>
                I want to note that the categorizations you see here are entirely my own work, that these do not come from a professional background. If you have suggestions on improving the website, please feel free to explore the project on GitHub. Your input and ideas are highly appreciated!
                    <br />
                    <br />
                Last Updated: Aug 31, 2023
                </p>
                   
            </div>
		</div>
  	);
}
export default About;
